import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Header from '../Header';
import '../../styles/pages/Success.css';
import { analytics } from '../../utils/analytics';

function Success() {
  const [orderDetails, setOrderDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const location = useLocation();

  useEffect(() => {
    // Track page view
    analytics.pageView('success', 'Order Success', window.location.href);

    const verifySession = async () => {
      const sessionId = new URLSearchParams(location.search).get('session_id');
      if (!sessionId) {
        setError('No session ID found');
        analytics.error('verification_error', 'No session ID found', 'Success');
        setLoading(false);
        return;
      }

      try {
        // First verify the session
        const response = await fetch(`${process.env.REACT_APP_API_URL}/verify-session/${sessionId}`);
        if (!response.ok) throw new Error('Failed to verify session');
        
        const data = await response.json();
        setOrderDetails(data);

        // Track successful purchase
        analytics.purchase(
          data.orderId,
          data.amount,
          data.quantity,
          data.expressShipping ? 'Express' : 'Standard'
        );

        // Then move to processing
        const moveResponse = await fetch(`${process.env.REACT_APP_API_URL}/move-to-processing`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ sessionId }),
        });

        if (!moveResponse.ok) {
          console.error('Failed to move order to processing');
          analytics.error('processing_error', 'Failed to move order to processing', 'Success');
        }
      } catch (err) {
        setError(err.message);
        analytics.error('verification_error', err.message, 'Success');
      } finally {
        setLoading(false);
      }
    };

    verifySession();
  }, [location]);

  return (
    <>
      <Header />
      <div className="success-page">
        {loading ? (
          <div className="success-content loading">Verifying your order...</div>
        ) : error ? (
          <div className="success-content error">Error: {error}</div>
        ) : (
          <div className="success-content">
            <div className="success-header">
              <h1>Thank You for Your Order!</h1>
              <div className="order-confirmation">
                Order #{orderDetails?.orderId}
              </div>
            </div>

            <div className="order-summary">
              <h2>Order Summary</h2>
              <div className="order-details">
                <div className="detail-row">
                  <span>Quantity:</span>
                  <span>{orderDetails?.quantity}</span>
                </div>
                <div className="detail-row">
                  <span>Shipping:</span>
                  <span>{orderDetails?.expressShipping ? 'Express' : 'Standard'}</span>
                </div>
                <div className="detail-row">
                  <span>Total Paid:</span>
                  <span>${(orderDetails?.amount / 100).toFixed(2)} AUD</span>
                </div>
              </div>
            </div>

            <div className="next-steps">
              <h2>What's Next?</h2>
              <ol>
                <li>Your tile will be printed within 24 hours</li>
                <li>You'll receive a shipping confirmation email with tracking details</li>
                <li>Expected delivery: {orderDetails?.expressShipping ? '2-4' : '5-7'} business days</li>
              </ol>
            </div>

            <div className="support-info">
              <p>Questions about your order? Contact us at support@printmytile.com</p>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default Success; 